import React from 'react';

import { textFromField } from '../../lib/mathOcrUi';

export function RecordsList({ records, selectedId, onSelectRecord, onOpenQuestionMenu }) {
  return (
    <div className="records">
      {(records || []).map((r) => {
        const isSelected = r?.id === selectedId;
        const hasRange = Array.isArray(r.page_range) && r.page_range.length >= 2;
        const pageLabel = hasRange ? `${r.page_range[0]}..${r.page_range[1]}` : 'n/a';

        return (
          <div
            key={r.id}
            className={`record${isSelected ? ' selected' : ''}`}
            data-id={r.id}
            onClick={() => onSelectRecord?.(r)}
          >
            <div className="recordHeadRow">
              <h4>
                {r.id} — pages {pageLabel} {r.needs_review ? '(needs_review)' : ''}
              </h4>
              <button
                type="button"
                className="recordMenuBtn"
                title="Question actions"
                aria-label="Question actions"
                onClick={(ev) => {
                  ev.stopPropagation();
                  const rect = ev.currentTarget.getBoundingClientRect();
                  onOpenQuestionMenu?.(rect.right + 6, rect.bottom + 4, r.id);
                }}
              >
                ⋮
              </button>
            </div>
            <div className="small">{textFromField(r.question).slice(0, 250)}</div>
          </div>
        );
      })}
    </div>
  );
}

